<template>
  <div class="BSCTabs">
    <div
      class="BSCTabs-item"
      :class="[
        `is-${type}`,
        { 'BSCTabs-item-selected': cell == tabs[currentElementIndex] }
      ]"
      ref="tabItem"
      v-for="(cell, index) in tabs"
      :key="index"
      @click="selected(cell)"
    >
      {{ cell.label }}
    </div>
    <div class="selectedItem" :class="[`is-${type}`]" ref="selectedItem"></div>
  </div>
</template>

<script>
'use strict'

import { isEqual } from 'lodash'

export default {
  name: 'BSCTabs',
  inheritAttrs: false,
  props: {
    value: Object,
    tabs: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      cellsWidth: []
    }
  },
  computed: {
    currentElementIndex() {
      return this.tabs.findIndex(item => isEqual(item, this.value)) //The index of the current cell element in tabs
    }
  },
  methods: {
    selected(el) {
      this.$emit('selected', el)
      this.$emit('input', el)
    },

    getDistance() {
      let leftPos = 0

      for (let i = 0; i < this.currentElementIndex; i++) {
        leftPos += this.cellsWidth[i] + 5 //Calc the pos based on previous elements width + 5 for the margin
      }

      this.$refs.selectedItem.style.width =
        this.cellsWidth[this.currentElementIndex] + 'px' //Set the width of current object

      this.$refs.selectedItem.style.left = leftPos + 'px' //Set the left pos of current object
    }
  },
  watch: {
    value(value) {
      this.getDistance(value) //On update, recalculate the pos and width of the current element
    }
  },
  mounted() {
    this.$refs.tabItem.forEach(
      item => this.cellsWidth.push(item.getBoundingClientRect().width) //Init the width of all cell
    )

    this.getDistance(this.value)
  }
}
</script>

<style lang="scss"></style>
